import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import "moment-timezone";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function ViewAbsentReport() {
  const [loader, setLoader] = useState(false)
  const { id } = useParams();
  const [absent, setAbsent] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [data, setData] = useState([]);
  const [medium, setMedium] = useState([]);
  const [standard, setStandard] = useState([]);
  const pdfRef = useRef();
  const [loading, setLoading] = useState(false);


  const studentInfoRef = useRef();
  const welcomeRef = useRef();
  const absentRef = useRef();
  const homeworkRef = useRef();
  const weeklyRef = useRef();
  const ptmRef = useRef();

  // const generatePDF = async () => {
  //   setLoading(true);

  //   const pdf = new jsPDF("landscape", "mm", "letter");

  //   const sections = [
  //     studentInfoRef,
  //     welcomeRef,
  //     absentRef,
  //     homeworkRef,
  //     weeklyRef,
  //     ptmRef
  //   ];

  //   const margin = 10; // Default margin like print setting
  //   const scale = 0.79; // 79% like in preview

  //   for (let i = 0; i < sections.length; i++) {
  //     const input = sections[i].current;
  //     if (!input) continue;

  //     const canvas = await html2canvas(input, {
  //       scale: 2, // high quality
  //       useCORS: true, // keep images
  //       backgroundColor: "#ffffff" // background graphics
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     const pdfWidth = pdf.internal.pageSize.getWidth() - margin * 2;
  //     const pdfHeight = pdf.internal.pageSize.getHeight() - margin * 2;

  //     const imgWidth = canvas.width * scale;
  //     const imgHeight = canvas.height * scale;
  //     const ratio = pdfWidth / imgWidth;

  //     let heightLeft = imgHeight * ratio;
  //     let position = margin;

  //     if (i > 0) pdf.addPage();
  //     pdf.addImage(
  //       imgData,
  //       "PNG",
  //       margin,
  //       position,
  //       pdfWidth,
  //       imgHeight * ratio
  //     );
  //     heightLeft -= pdfHeight;

  //     while (heightLeft > 0) {
  //       position = margin - (imgHeight * ratio - heightLeft);
  //       pdf.addPage();
  //       pdf.addImage(
  //         imgData,
  //         "PNG",
  //         margin,
  //         position,
  //         pdfWidth,
  //         imgHeight * ratio
  //       );
  //       heightLeft -= pdfHeight;
  //     }
  //   }

  //   pdf.save("Portfolio.pdf");
  //   setLoading(false);
  // };
  const generatePDF = async () => {
  setLoading(true);

  const pdf = new jsPDF("landscape", "mm", "letter");

  const sections = [
    studentInfoRef,
    welcomeRef,
    absentRef,
    homeworkRef,
    weeklyRef,
    ptmRef
  ];

  const margin = 10; 
  const scale = 0.79;

  for (let i = 0; i < sections.length; i++) {
    const input = sections[i].current;
    if (!input) continue;

    // Higher scale → more detail → larger size
    const canvas = await html2canvas(input, {
      scale: 1.6, // slightly higher than before (1.2 → 1.6)
      useCORS: true,
      backgroundColor: "#ffffff"
    });

    // Increase JPEG quality (0.5 → 0.8)
    const imgData = canvas.toDataURL("image/jpeg", 0.8);

    const pdfWidth = pdf.internal.pageSize.getWidth() - margin * 2;
    const pdfHeight = pdf.internal.pageSize.getHeight() - margin * 2;

    const imgWidth = canvas.width * scale;
    const imgHeight = canvas.height * scale;
    const ratio = pdfWidth / imgWidth;

    let heightLeft = imgHeight * ratio;
    let position = margin;

    if (i > 0) pdf.addPage();
    pdf.addImage(
      imgData,
      "JPEG",
      margin,
      position,
      pdfWidth,
      imgHeight * ratio,
      undefined,
      "FAST"
    );

    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position = margin - (imgHeight * ratio - heightLeft);
      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        margin,
        position,
        pdfWidth,
        imgHeight * ratio,
        undefined,
        "FAST"
      );
      heightLeft -= pdfHeight;
    }
  }

  pdf.save("Portfolio.pdf");
  setLoading(false);
};





  const getMediumData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/medium`
      );

      if (res.status === 200) {
        setMedium(res.data.data);
      } else {
        setMedium([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  const getStandardData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/standerd`
      );

      if (res.status === 200) {
        setStandard(res.data.data);
      } else {
        setStandard([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  const getStudentData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/student/${id}`
      );
      if (res.status === 200) {
        setData({
          name: res.data.data[0].name,
          gender: res.data.data[0].gender,
          id_branch: res.data.data[0].id_branch,
          id_board: res.data.data[0].id_board,
          id_medium: res.data.data[0].id_medium,
          id_standard: res.data.data[0].id_standard,
          id_batch: res.data.data[0].id_batch,
          id_course: res.data.data[0].id_course,
          id_reference_type: res.data.data[0].id_reference_type,
          school: res.data.data[0].school,
          id_shift: res.data.data[0].id_shift,
          reference_name: res.data.data[0].reference_name,
          contact_1: res.data.data[0].contact_1,
          contact_2: res.data.data[0].contact_2,
          birth_date: res.data.data[0].birth_date,
          address: res.data.data[0].address,
          pincode: res.data.data[0].pincode,
          remark: res.data.data[0].remark,
          last_result: res.data.data[0].last_result,
          fathers_name: res.data.data[0].fathers_name,
          fathers_occupation: res.data.data[0].fathers_occupation,
          fathers_contact: res.data.data[0].fathers_contact,
          mothers_name: res.data.data[0].mothers_name,
          mothers_occupation: res.data.data[0].mothers_occupation,
          mothers_contact: res.data.data[0].mothers_contact,
          sibling_name: res.data.data[0].sibling_name,
          sibling_relation: res.data.data[0].sibling_relation,
          sibling_board: res.data.data[0].sibling_board,
          sibling_medium: res.data.data[0].sibling_medium,
          sibling_standard: res.data.data[0].sibling_standard,
          sibling_school: res.data.data[0].sibling_school,
          sibling_tution_name: res.data.data[0].sibling_tution_name,
          admission_date: res.data.data[0].admission_date,
          photo: res.data.data[0].photo,
        });
      } else {
        setData([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  const getMediumNameById = (m_Id) => {
    const foundMedium = medium.find((medium) => medium.id === m_Id);
    return foundMedium ? foundMedium.medium : "Unknown medium";
  };
  const getStandardNameById = (standardId) => {
    const foundStandard = standard.find(
      (standard) => standard.id === standardId
    );
    return foundStandard ? foundStandard.standard : "Unknown standard";
  };
  const handleimg = (e) => {
    e.target.src = "/assets/img/user1.png";
    e.target.alt = "Image not found";
  };
  //maths report
  const [maths, setMaths] = useState([]);
  const getMathsReportData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getbyidmathsreportstudent/${id}`
      );

      if (res.status === 200) {
        setMaths(res.data.data);
      } else {
        setMaths([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  //english report
  const [english, setEnglish] = useState([]);
  const getEnglishReportData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getEnglishReportByIdStudent/${id}`
      );

      if (res.status === 200) {
        setEnglish(res.data.data);
      } else {
        setEnglish([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  //Gujaratu report
  const [gujarati, setGujarati] = useState([]);
  const getGujaratiReportData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getGujaratiReportByIdStudent/${id}`
      );

      if (res.status === 200) {
        setGujarati(res.data.data);
      } else {
        setGujarati([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  //Welcome report
  const [welcome, setWelcome] = useState([]);
  const getWelcomeReportData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getWelcomeReportByIdStudent/${id}`
      );

      if (res.status === 200) {
        setWelcome(res.data.data);
      } else {
        setWelcome([]);
      }
    } catch (error) {
      console.log(error);
      setLoader(true)
    }
  };
  //attendance
  const getAttendanceData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getWeeklyAttendance/${id}`
      );
      if (res.status === 200 && res.data.data.length > 0) {
        setAbsent(res.data.data);
      } else {
        setAbsent([]);
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };
  const getSubjectData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getsubject`
      );
      if (res.status === 200) {
        setSubjects(res.data.data);
      } else {
        setSubjects([]);
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };
  const getSubjectNameById = (subjectId) => {
    const foundSubject = subjects.find((subject) => subject.id === subjectId);
    return foundSubject ? foundSubject.subject : "Unknown subject";
  };
  const organizeData = (apiData) => {
    const organizedData = {};

    apiData.forEach((item) => {
      const { month, week, id_subject, absentCount } = item;

      if (!organizedData[month]) {
        organizedData[month] = {};
      }

      if (!organizedData[month][id_subject]) {
        organizedData[month][id_subject] = {};
      }

      organizedData[month][id_subject][week] = absentCount;
    });

    return organizedData;
  };


  const organizedData = organizeData(absent);
  // Home work data
  const [homework, setHomework] = useState([]);
  const getHomeWorData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/homeworkstatus/${id}`
      );
      if (res.status === 200 && res.data.data.length > 0) {
        setHomework(res.data.data);
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };

  const organizeDataHomework = (apiData) => {
    const organizedDataHomework = {};

    apiData.forEach((item) => {
      let { month, week, id_subject, notDoneCount } = item;

      // Convert week 5 into week 4
      if (week > 4) week = 4;

      if (!organizedDataHomework[month]) {
        organizedDataHomework[month] = {};
      }

      if (!organizedDataHomework[month][id_subject]) {
        organizedDataHomework[month][id_subject] = {};
      }

      if (!organizedDataHomework[month][id_subject][week]) {
        organizedDataHomework[month][id_subject][week] = 0;
      }

      // Add to count (in case multiple entries fall in same subject/month/week)
      organizedDataHomework[month][id_subject][week] += notDoneCount;
    });

    return organizedDataHomework;
  };

  const organizedDataHomework = organizeDataHomework(homework);
  const allSubjectIds = [...new Set(homework.map(item => item.id_subject))];
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const monthKeys = Object.keys(organizedDataHomework);
  const monthChunks = chunkArray(monthKeys, 3);


  // Get all unique subject IDs from the absent data
  const allAbsentSubjectIds = [...new Set(absent.map(item => item.id_subject))];
  const absentMonthKeys = Object.keys(organizedData);
  const absentMonthChunks = chunkArray(absentMonthKeys, 3);


  //Weekly Exam Result
  const [weeklyExam, SetWeeklyExam] = useState([]);
  const getWeeklyExamData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/exammarksreport/${id}`
      );
      if (res.status === 200 && res.data.data.length > 0) {
        SetWeeklyExam(res.data.data);
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };
  const calculatePercentage = (marks, totalMarks) => {
    if (totalMarks === 0) {
      return "N/A"; // to handle division by zero
    }

    const percentage = ((marks / totalMarks) * 100).toFixed(2);
    return percentage;
  };
  const convertDateFormat = (dateString) => {
    const convertedDate = moment(dateString)
      .tz("Asia/Kolkata")
      .format("DD-MM-YYYY");
    return convertedDate;
  };
  //weeklyexamresultreport
  const [monthlyData, setMonthlyData] = useState({});
  useEffect(() => {
    getWeeklyExamResultData();
  }, [id]); // Trigger the API call whenever the 'id' prop changes
  const getMonthName = (monthKey) => {
    const monthNumber = parseInt(monthKey.split("_")[1]);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthNumber - 1] || "";
  };
  const getWeeklyExamResultData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getexammarksportfoliyo/${id}`
      );
      if (
        res.status === 200 &&
        res.data.success === 0 &&
        res.data.data.length > 0
      ) {
        setMonthlyData(
          res.data.data.flatMap(item => {
            const monthKey = Object.keys(item)[0];
            return item[monthKey].map(entry => ({
              ...entry,
              month: getMonthName(monthKey),
            }));
          }).reduce((acc, entry) => {
            if (!acc[entry.subject]) {
              acc[entry.subject] = [];
            }
            acc[entry.subject].push(entry);
            return acc;
          }, {})
        );

      } else {
        setMonthlyData({});
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };
  //PTM Report
  const [ptm, setPtm] = useState([]);
  const [user, setUser] = useState([]);
  const getPTMReport = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/ptmreport/${id}`
      );
      if (res.status === 200 && res.data.data.length > 0) {
        setPtm(res.data.data);
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };
  const getUserData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/admin`
      );
      if (res.status === 200) {
        setUser(res.data.data);
      } else {
        setUser([]);
      }
    } catch (err) {
      console.log(err);
      setLoader(true)
    }
  };
  const getTeacherNameById = (teacherId) => {
    const foundTeacher = user.find((teacher) => teacher.id === teacherId);
    return foundTeacher ? foundTeacher.name : "Unknown Teacher";
  };
  useEffect(() => {
    getAttendanceData();
    getHomeWorData();
    getSubjectData();
    getWeeklyExamData();
    getPTMReport();
    getUserData();
    getStudentData();
    getMediumData();
    getStandardData();
    getMathsReportData();
    getEnglishReportData();
    getGujaratiReportData();
    getWelcomeReportData();
  }, []);

  if (loader) {
    return (<div className="page-wrapper page-settings">
      <div className="error">
        <svg data-name="Layer 1" width="1119.60911" height="699" viewBox="0 0 1119.60911 699">
          <title>server down</title>
          <circle cx="292.60911" cy="213" r="213" fill="#f2f2f2" /><path d="M31.39089,151.64237c0,77.49789,48.6181,140.20819,108.70073,140.20819" transform="translate(-31.39089 -100.5)" fill="#2f2e41" /><path d="M140.09162,291.85056c0-78.36865,54.255-141.78356,121.30372-141.78356" transform="translate(-31.39089 -100.5)" fill="#6b9647" />          <path d="M70.77521,158.66768c0,73.61476,31.00285,133.18288,69.31641,133.18288" transform="translate(-31.39089 -100.5)" fill="#6b9647" />          <path d="M140.09162,291.85056c0-100.13772,62.7103-181.16788,140.20819-181.16788" transform="translate(-31.39089 -100.5)" fill="#2f2e41" />          <path d="M117.22379,292.83905s15.41555-.47479,20.06141-3.783,23.713-7.2585,24.86553-1.95278,23.16671,26.38821,5.76263,26.5286-40.43935-2.711-45.07627-5.53549S117.22379,292.83905,117.22379,292.83905Z" transform="translate(-31.39089 -100.5)" fill="#a8a8a8" />          <path d="M168.224,311.78489c-17.40408.14042-40.43933-2.71094-45.07626-5.53548-3.53126-2.151-4.93843-9.86945-5.40926-13.43043-.32607.014-.51463.02-.51463.02s.97638,12.43276,5.61331,15.2573,27.67217,5.67589,45.07626,5.53547c5.02386-.04052,6.7592-1.82793,6.66391-4.47526C173.87935,310.756,171.96329,311.75474,168.224,311.78489Z" transform="translate(-31.39089 -100.5)" opacity="0.2" />          <ellipse cx="198.60911" cy="424.5" rx="187" ry="25.43993" fill="#3f3d56" />          <ellipse cx="198.60911" cy="424.5" rx="157" ry="21.35866" opacity="0.1" />          <ellipse cx="836.60911" cy="660.5" rx="283" ry="38.5" fill="#3f3d56" />          <ellipse cx="310.60911" cy="645.5" rx="170" ry="23.12721" fill="#3f3d56" />          <path d="M494,726.5c90,23,263-30,282-90" transform="translate(-31.39089 -100.5)" fill="none" stroke="#2f2e41" stroke-miterlimit="10" stroke-width="2" />          <path d="M341,359.5s130-36,138,80-107,149-17,172" transform="translate(-31.39089 -100.5)" fill="none" stroke="#2f2e41" stroke-miterlimit="10" stroke-width="2" />          <path d="M215.40233,637.78332s39.0723-10.82,41.47675,24.04449-32.15951,44.78287-5.10946,51.69566" transform="translate(-31.39089 -100.5)" fill="none" stroke="#2f2e41" stroke-miterlimit="10" stroke-width="2" />          <path d="M810.09554,663.73988,802.218,714.03505s-38.78182,20.60284-11.51335,21.20881,155.73324,0,155.73324,0,24.84461,0-14.54318-21.81478l-7.87756-52.719Z" transform="translate(-31.39089 -100.5)" fill="#2f2e41" />          <path d="M785.21906,734.69812c6.193-5.51039,16.9989-11.252,16.9989-11.252l7.87756-50.2952,113.9216.10717,7.87756,49.582c9.185,5.08711,14.8749,8.987,18.20362,11.97818,5.05882-1.15422,10.58716-5.44353-18.20362-21.38921l-7.87756-52.719-113.9216,3.02983L802.218,714.03506S769.62985,731.34968,785.21906,734.69812Z" transform="translate(-31.39089 -100.5)" opacity="0.1" /><rect x="578.43291" y="212.68859" width="513.25314" height="357.51989" rx="18.04568" fill="#2f2e41" /><rect x="595.70294" y="231.77652" width="478.71308" height="267.83694" fill="#3f3d56" /><circle cx="835.05948" cy="223.29299" r="3.02983" fill="#f2f2f2" /><path d="M1123.07694,621.32226V652.6628a18.04341,18.04341,0,0,1-18.04568,18.04568H627.86949A18.04341,18.04341,0,0,1,609.8238,652.6628V621.32226Z" transform="translate(-31.39089 -100.5)" fill="#2f2e41" /><polygon points="968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 651.452 645.651 962.312 645.651 968.978 667.466" fill="#2f2e41" /><path d="M1125.828,762.03359c-.59383,2.539-2.83591,5.21743-7.90178,7.75032-18.179,9.08949-55.1429-2.42386-55.1429-2.42386s-28.4804-4.84773-28.4804-17.573a22.72457,22.72457,0,0,1,2.49658-1.48459c7.64294-4.04351,32.98449-14.02122,77.9177.42248a18.73921,18.73921,0,0,1,8.54106,5.59715C1125.07908,756.45353,1126.50669,759.15715,1125.828,762.03359Z" transform="translate(-31.39089 -100.5)" fill="#2f2e41" /><path d="M1125.828,762.03359c-22.251,8.526-42.0843,9.1622-62.43871-4.975-10.26507-7.12617-19.59089-8.88955-26.58979-8.75618,7.64294-4.04351,32.98449-14.02122,77.9177.42248a18.73921,18.73921,0,0,1,8.54106,5.59715C1125.07908,756.45353,1126.50669,759.15715,1125.828,762.03359Z" transform="translate(-31.39089 -100.5)" opacity="0.1" /><ellipse cx="1066.53846" cy="654.13477" rx="7.87756" ry="2.42386" fill="#f2f2f2" /><circle cx="835.05948" cy="545.66686" r="11.51335" fill="#f2f2f2" /><polygon points="968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 968.978 667.466" opacity="0.1" /><rect x="108.60911" y="159" width="208" height="242" fill="#2f2e41" /><rect x="87.60911" y="135" width="250" height="86" fill="#3f3d56" /><rect x="87.60911" y="237" width="250" height="86" fill="#3f3d56" /><rect x="87.60911" y="339" width="250" height="86" fill="#3f3d56" /><rect x="271.60911" y="150" width="16" height="16" fill="#6b9647" opacity="0.4" /><rect x="294.60911" y="150" width="16" height="16" fill="#6b9647" opacity="0.8" /><rect x="317.60911" y="150" width="16" height="16" fill="#6b9647" /><rect x="271.60911" y="251" width="16" height="16" fill="#6b9647" opacity="0.4" /><rect x="294.60911" y="251" width="16" height="16" fill="#6b9647" opacity="0.8" /><rect x="317.60911" y="251" width="16" height="16" fill="#6b9647" /><rect x="271.60911" y="352" width="16" height="16" fill="#6b9647" opacity="0.4" /><rect x="294.60911" y="352" width="16" height="16" fill="#6b9647" opacity="0.8" /><rect x="317.60911" y="352" width="16" height="16" fill="#6b9647" /><circle cx="316.60911" cy="538" r="79" fill="#2f2e41" /><rect x="280.60911" y="600" width="24" height="43" fill="#2f2e41" /><rect x="328.60911" y="600" width="24" height="43" fill="#2f2e41" /><ellipse cx="300.60911" cy="643.5" rx="20" ry="7.5" fill="#2f2e41" /><ellipse cx="348.60911" cy="642.5" rx="20" ry="7.5" fill="#2f2e41" /><circle cx="318.60911" cy="518" r="27" fill="#fff" /><circle cx="318.60911" cy="518" r="9" fill="#3f3d56" /><path d="M271.36733,565.03228c-6.37889-28.56758,14.01185-57.43392,45.544-64.47477s62.2651,10.41,68.644,38.9776-14.51861,39.10379-46.05075,46.14464S277.74622,593.59986,271.36733,565.03228Z" transform="translate(-31.39089 -100.5)" fill="#6b9647" /><ellipse cx="417.21511" cy="611.34365" rx="39.5" ry="12.40027" transform="translate(-238.28665 112.98044) rotate(-23.17116)" fill="#2f2e41" /><ellipse cx="269.21511" cy="664.34365" rx="39.5" ry="12.40027" transform="translate(-271.07969 59.02084) rotate(-23.17116)" fill="#2f2e41" /><path d="M394,661.5c0,7.732-19.90861,23-42,23s-43-14.268-43-22,20.90861-6,43-6S394,653.768,394,661.5Z" transform="translate(-31.39089 -100.5)" fill="#fff" />
        </svg>
      </div>
    </div>)
  }
  const date = data.admission_date ? data.admission_date.split('T')[0] : 'Default Date';


  return (
    <>
      {loader ||
        <div className="">
          <div className="content">
            <div ref={pdfRef} className="portpholiopd">
              <div ref={studentInfoRef} style={{padding: '0 20px'}}>
                <div className="main">
                  <div className="hedar">
                    <div className="noble-logo">
                      <img
                        src="/assets/img/nobel2.png"
                        className="img-fluid logo"
                        alt=""
                      />
                    </div>
                    <div className="noble-text" style={{ alignContent: 'center' }}>
                      <h2>NOBLE ACADEMY</h2>
                      <h1>
                        <b>STUDENTS PORTFOLIO</b>
                      </h1>
                    </div>
                    <div className="hedar-roght" style={{ alignContent: 'center' }}>
                      <p>STD :- {getStandardNameById(data.id_standard)}</p>
                      <p>Medium :- {getMediumNameById(data.id_medium)}</p>
                      <p>Admission Date :- {convertDateFormat(data.admission_date)}</p>
                    </div>
                  </div>
                  <div className="container" style={{ maxWidth: '1500px' }}>
                    <div className="row mt-3">
                      <div className="col-3" style={{ alignContent: 'center' }}>
                        <div className="studemt-img" style={{ textAlign: 'center', alignItems: 'center' }}>
                          <img
                            src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/${data.photo}`}
                            className="img-fluid logo"
                            onError={handleimg}
                          />
                        </div>
                      </div>
                      <div className="col-9">
                        <div className="row mt-4">
                          <div className="col-4">
                            <div className="form-group">
                              <label>Student Name</label>
                              <input
                                type="text"
                                disabled
                                value={data.name}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-8">
                            <div className="form-group">
                              <label>Address</label>
                              <input
                                type="text"
                                disabled
                                placeholder="Address"
                                value={data.address}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label>Contact Number ( Self )</label>
                              <input
                                type="number"
                                disabled
                                value={data.contact_1}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label>Contact Number ( F )</label>
                              <input
                                type="number"
                                disabled
                                value={data.contact_2}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label>Parents Contact No. ( F )</label>
                              <input
                                type="number"
                                disabled
                                value={data.fathers_contact}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="form-group">
                              <label>Parents Contact No. ( M )</label>
                              <input
                                type="number"
                                disabled
                                value={data.mothers_contact}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-3">
                            <div className="form-group">
                              <label>Admission Date</label>
                              <input
                                type="date"
                                disabled
                                value={date}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-2">
                            <div className="form-group">
                              <label>Last Year Results</label>
                              <input
                                type="text"
                                disabled
                                value={data.last_result + '%'}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-7">
                            <div className="form-group">
                              <label>School Name</label>
                              <input
                                type="text"
                                disabled
                                value={data.school}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Welcome Test Results      */}
                <div className="content-page-header content-page-headersplit mt-5">
                  <h5>Welcome Report</h5>
                </div>
                <div className="welcome-test">
                  <div className="row bord">
                    <div className="col-12 subject">
                      <div className="row">
                        <div className="col-12 mainmonth">
                          <table style={{ width: "100%" }} className="month">
                            <thead>
                              <tr>
                                <th colSpan="13">Welcome Report</th>
                              </tr>
                              <tr>
                                <th>Date</th>
                                <th>Total Marks</th>
                                <th>Simple Plus (+)</th>
                                <th>Point Plus (+)</th>
                                <th>Simple Minus ( - )</th>
                                <th>Point Minus ( - )</th>
                                <th>Simple Multiplied by ( x )</th>
                                <th>Point Multiplied by ( x )</th>
                                <th>Simple Divided by ( ÷ )</th>
                                <th>Point Divided by ( ÷ )</th>
                                <th>Gujarati Reading</th>
                                <th>English Reading</th>
                                <th>Get Marks </th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {welcome.length === 0 ? (
                                <td colSpan="12">No data available</td>
                              ) : (
                                welcome.map((dataa, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{convertDateFormat(dataa.created_at)}</td>
                                      <td>{dataa.total_marks}</td>
                                      <td>
                                        {dataa.add_s
                                          ? dataa.add_s.charAt(0).toUpperCase() +
                                          dataa.add_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.add_p
                                          ? dataa.add_p.charAt(0).toUpperCase() +
                                          dataa.add_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.sub_s
                                          ? dataa.sub_s.charAt(0).toUpperCase() +
                                          dataa.sub_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.sub_p
                                          ? dataa.sub_p.charAt(0).toUpperCase() +
                                          dataa.sub_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.mult_s
                                          ? dataa.mult_s
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.mult_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.mult_p
                                          ? dataa.mult_p
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.mult_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.div_s
                                          ? dataa.div_s
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.div_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.div_p
                                          ? dataa.div_p
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.div_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.gujarati_read
                                          ? dataa.gujarati_read
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.gujarati_read.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.english_read
                                          ? dataa.english_read
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.english_read.slice(1)
                                          : "-"}
                                      </td>
                                      <td>{dataa.marks}</td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome-test">
                  <div className="row bord">
                    <div className="col-12 subject">
                      <div className="row">
                        <div className="col-12 mainmonth">
                          <table style={{ width: "100%" }} className="month">
                            <thead>
                              <tr>
                                <th colSpan="12">Gujarati Report</th>
                              </tr>
                              <tr>
                                <th>Date</th>
                                <th>મૂળાક્ષર ની ઓળખ</th>
                                <th>બારાક્ષરી</th>
                                <th>સાદા શબ્દો</th>
                                <th>કાના માત્રા વાળા શબ્દ</th>
                                <th>અર્ધ અક્ષર વાળા શબ્દ</th>
                                <th>અટકી અટકી ને વાચે છે</th>
                                <th>Hand Writing</th>
                                <th>મોઢે લખાણ કેવુ છે	</th>
                                <th>Reading</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {gujarati.length === 0 ? (
                                <td colSpan="12">No data available</td>
                              ) : (
                                gujarati.map((dataa, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{convertDateFormat(dataa.created_at)}</td>
                                      <td>
                                        {dataa.recognition_alphabets
                                          ? dataa.recognition_alphabets.charAt(0).toUpperCase() +
                                          dataa.recognition_alphabets.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.barakshari
                                          ? dataa.barakshari.charAt(0).toUpperCase() +
                                          dataa.barakshari.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.simple_words
                                          ? dataa.simple_words.charAt(0).toUpperCase() +
                                          dataa.simple_words.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.vovels
                                          ? dataa.vovels.charAt(0).toUpperCase() +
                                          dataa.vovels.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.half_lettered
                                          ? dataa.half_lettered
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.half_lettered.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.stops_reads
                                          ? dataa.stops_reads
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.stops_reads.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.mouth_sore
                                          ? dataa.mouth_sore
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.mouth_sore.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.hand_writing
                                          ? dataa.hand_writing
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.hand_writing.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.reading
                                          ? dataa.reading
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.reading.slice(1)
                                          : "-"}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome-test">
                  <div className="row bord">
                    <div className="col-12 subject">
                      <div className="row">
                        <div className="col-12 mainmonth">
                          <table style={{ width: "100%" }} className="month">
                            <thead>
                              <tr>
                                <th colSpan="12">English Report</th>
                              </tr>
                              <tr>
                                <th>Date</th>
                                <th>Alphabets</th>
                                <th>Basic Words</th>
                                <th>Three Tetter Words</th>
                                <th>A Sound</th>
                                <th>I Sound</th>
                                <th>E Sound</th>
                                <th>Reading Pattern</th>
                                <th>Hand Writing</th>
                                <th>Capital Letter Problem</th>
                                <th>Basic Words Spelling</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {english.length === 0 ? (
                                <td colSpan="12">No data available</td>
                              ) : (
                                english.map((dataa, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{convertDateFormat(dataa.created_at)}</td>
                                      <td>{dataa.alphabets}</td>
                                      <td>
                                        {dataa.basic_words
                                          ? dataa.basic_words.charAt(0).toUpperCase() +
                                          dataa.basic_words.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.three_letter_words
                                          ? dataa.three_letter_words.charAt(0).toUpperCase() +
                                          dataa.three_letter_words.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.a_sound
                                          ? dataa.a_sound.charAt(0).toUpperCase() +
                                          dataa.a_sound.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.i_sound
                                          ? dataa.i_sound.charAt(0).toUpperCase() +
                                          dataa.i_sound.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.e_sound
                                          ? dataa.e_sound
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.e_sound.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.reading_pattern
                                          ? dataa.reading_pattern
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.reading_pattern.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.hand_writing
                                          ? dataa.hand_writing
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.hand_writing.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.capital_letter_problem
                                          ? dataa.capital_letter_problem
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.capital_letter_problem.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.basic_words_spelling
                                          ? dataa.basic_words_spelling
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.basic_words_spelling.slice(1)
                                          : "-"}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="welcome-test">
                  <div className="row bord">
                    <div className="col-12 subject">
                      <div className="row">
                        <div className="col-12 mainmonth">
                          <table style={{ width: "100%" }} className="month">
                            <thead>
                              <tr>
                                <th colSpan="12">Maths Report</th>
                              </tr>
                              <tr>
                                <th>Date</th>
                                <th>Exam Marks</th>
                                <th>Simple (+)</th>
                                <th>Point (+)</th>
                                <th>Simple (-)</th>
                                <th>Point (-)</th>
                                <th>Simple (x)</th>
                                <th>Point (x)</th>
                                <th>Simple (÷)</th>
                                <th>Point (÷)</th>
                                <th>Marks</th>
                                <th>Percent %</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {maths.length === 0 ? (
                                <td colSpan="12">No data available</td>
                              ) : (
                                maths.map((dataa, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{convertDateFormat(dataa.created_at)}</td>
                                      <td>{dataa.total_marks}</td>
                                      <td>
                                        {dataa.plus_s
                                          ? dataa.plus_s.charAt(0).toUpperCase() +
                                          dataa.plus_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.plus_p
                                          ? dataa.plus_p.charAt(0).toUpperCase() +
                                          dataa.plus_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.minus_s
                                          ? dataa.minus_s.charAt(0).toUpperCase() +
                                          dataa.minus_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.minus_p
                                          ? dataa.minus_p.charAt(0).toUpperCase() +
                                          dataa.minus_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.multiplied_by_s
                                          ? dataa.multiplied_by_s
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.multiplied_by_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.multiplied_by_p
                                          ? dataa.multiplied_by_p
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.multiplied_by_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.divided_by_s
                                          ? dataa.divided_by_s
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.divided_by_s.slice(1)
                                          : "-"}
                                      </td>
                                      <td>
                                        {dataa.divided_by_p
                                          ? dataa.divided_by_p
                                            .charAt(0)
                                            .toUpperCase() +
                                          dataa.divided_by_p.slice(1)
                                          : "-"}
                                      </td>
                                      <td>{dataa.marks}</td>
                                      <td>
                                        {calculatePercentage(
                                          dataa.marks,
                                          dataa.total_marks
                                        )}
                                        %
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/*     Absent Report     */}
              <div ref={absentRef} style={{padding: '0 20px'}}>
                <div className="content-page-header content-page-headersplit mt-5">
                  <h5>Absent Report</h5>
                </div>
                {absentMonthChunks.map((chunk, rowIndex) => (
                  <div className="row bord" key={rowIndex}>
                    {/* Subject Column */}
                    <div className="col-1 subject">
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr><th>Subject</th></tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {allAbsentSubjectIds.map((subjectId) => (
                            <tr key={subjectId}>
                              <td>{getSubjectNameById(subjectId)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Month Columns */}
                    <div className="col-11 subject">
                      <div className="row">
                        {chunk.map((month) => (
                          <div key={month} className="col-4 mainmonth">
                            <table style={{ width: "100%" }} className="month">
                              <thead>
                                <tr>
                                  <th colSpan="6">
                                    {moment().month(month - 1).format("MMMM")}
                                  </th>
                                </tr>
                                <tr>
                                  <th>1st</th>
                                  <th>2nd</th>
                                  <th>3rd</th>
                                  <th>4th</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allAbsentSubjectIds.map((subjectId) => (
                                  <tr key={subjectId}>
                                    {[1, 2, 3, 4, "total"].map((weekDay) => (
                                      <td key={weekDay}>
                                        {weekDay === "total"
                                          ? Object.keys(organizedData[month]?.[subjectId] || {}).reduce(
                                            (total, wk) =>
                                              total + (organizedData[month]?.[subjectId]?.[wk] || 0),
                                            0
                                          )
                                          : organizedData[month]?.[subjectId]?.[weekDay] || "-"}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/*  Homework Report */}
              <div ref={homeworkRef} style={{padding: '0 20px'}}>
                <div className="content-page-header content-page-headersplit mt-5">
                  <h5>Homework Report</h5>
                </div>
                {monthChunks.map((chunk, rowIndex) => (
                  <div className="row bord" key={rowIndex}>
                    {/* Subject Column */}
                    <div className="col-1 subject">
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr><th>Subject</th></tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                          {allSubjectIds.map((subjectId) => (
                            <tr key={subjectId}>
                              <td>{getSubjectNameById(subjectId)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Month Columns */}
                    <div className="col-11 subject">
                      <div className="row">
                        {chunk.map((month) => (
                          <div key={month} className="col-4 mainmonth">
                            <table style={{ width: "100%" }} className="month">
                              <thead>
                                <tr>
                                  <th colSpan="6">
                                    {moment().month(month - 1).format("MMMM")}
                                  </th>
                                </tr>
                                <tr>
                                  <th>1st</th>
                                  <th>2nd</th>
                                  <th>3rd</th>
                                  <th>4th</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {allSubjectIds.map((subjectId) => (
                                  <tr key={subjectId}>
                                    {[1, 2, 3, 4, "total"].map((weekDay) => (
                                      <td key={weekDay}>
                                        {weekDay === "total"
                                          ? Object.keys(organizedDataHomework[month]?.[subjectId] || {}).reduce(
                                            (total, wk) =>
                                              total + (organizedDataHomework[month]?.[subjectId]?.[wk] || 0),
                                            0
                                          )
                                          : organizedDataHomework[month]?.[subjectId]?.[weekDay] || "-"}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/*        Weekly Short Exam Result        */}
              <div ref={weeklyRef} style={{padding: '0 20px'}}>
                <div className="content-page-header content-page-headersplit mt-5">
                  <h5>Weekly Exam Result Report</h5>
                </div>

                <div className="welcome-test">
                  {Object.keys(monthlyData).map((subjectId) => (
                    <>
                      <div className="exam-title">
                        <h6>{getSubjectNameById(Number(subjectId))}</h6>
                      </div>
                      <div className="row bord mb-3">
                        <div key={subjectId} className="col-12 subject">
                          <table style={{ width: "100%" }} className="month">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Exam</th>
                                <th>Syllabus</th>
                                <th>Total Marks</th>
                                <th>Result</th>
                                <th>Percentage</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {monthlyData[subjectId].length === 0 ? (
                                <tr>
                                  <td colSpan="7">No data available</td>
                                </tr>
                              ) : (
                                monthlyData[subjectId].map((item, index) => {
                                  const percentage = item.total_marks
                                    ? ((item.result / item.total_marks) * 100).toFixed(2)
                                    : "0.00";
                                  return (
                                    <tr key={index}>
                                      <td>{item.date.split("T")[0]}</td>
                                      <td>{item.exam}</td>
                                      <td>{item.syllabus}</td>
                                      <td>{item.total_marks}</td>
                                      <td>{item.result}</td>
                                      <td>{percentage}%</td>
                                      <td>{item.remark}</td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              {/*   PTM Report    */}
              <div ref={ptmRef} style={{padding: '0 20px'}}>
                <div className="content-page-header content-page-headersplit mt-5">
                  <h5>PTM Report</h5>
                </div>
                <div className="row">
                  <div className="col-12 ">
                    <div className="table-responsive">
                      <table className="table datatable">
                        <thead>
                          <tr>
                            <th>Index</th>
                            <th>Meering Date</th>
                            <th>Teacher</th>
                            <th>Reason</th>
                            <th>Purpose</th>
                            <th>Presence Either Attend Yes/No </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {ptm.length === 0 ? (
                            <td colSpan="12">No data available</td>
                          ) : (
                            ptm.reverse().map((dataa, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{dataa.meeting_date}</td>
                                  <td>{getTeacherNameById(dataa.id_teachar)}</td>
                                  <td>{dataa.meeting_title}</td>
                                  <td>{dataa.meeting_purpose}</td>
                                  <td>{dataa.presence_parent}</td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {
              loading
                ?
                <>
                  <button className="btn btn-primary protbut" type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" style={{ marginRight: "10px" }} aria-hidden="true"></span>
                    Loading...
                  </button>
                </>
                :
                <button onClick={generatePDF} className="btn btn-primary protbut">Download PDF</button>
            }

          </div>
        </div>
      }

    </>
  );
}

export default ViewAbsentReport;